const setBack = (state, action) => action.back || state;
export default setBack;
